/* eslint-disable */
import React, {useEffect, useState} from "react";
import {evaluatePromptWithAi, Practice} from "../../../../api/lessonsService";
import {PromptCreationDialog} from "../PromptCreationBlock/PromptCreationDialog";
import './PracticeBlocks.css';
import {useLessonStore} from "../../../../store/useLessonStore";
interface PromptCreationPracticeProps {
    practice: Practice;
    lessonId: number;
    fragmentIndex: number;
    courseId: string;
    currentFragmentId: number;
    onStart: () => void;
    onCompleted?: () => void;
    onMoveNext?: () => void;
}


export const PromptCreationPractice: React.FC<PromptCreationPracticeProps> = ({
 practice,
 lessonId,
 fragmentIndex,
 onStart,
 onCompleted,
 courseId,
 currentFragmentId,
 onMoveNext
}) => {
    const {lessonProgressData, lessonData } = useLessonStore();
    const [showDialog, setShowDialog] = useState(false);
    const [evaluationResult, setEvaluationResult] = useState<any>(null);
    const [isEvaluating, setIsEvaluating] = useState(false);
    const [isCompleted, setCompleted] = useState(false)
    const [isSkip, setSkipStatus] = useState(false)
    const promptCreationData = practice.promptCreation;


    useEffect(() => {
        const currentFragment = lessonData?.fragments.find((fr: any) => fr.id === currentFragmentId)
        if (!currentFragment){
            setCompleted(false)
        }

        // Check if the current fragment has progress data
        const fragmentProgress = lessonProgressData.find((fp:any) => fp.fragmentId === currentFragment?.id);
        if (!fragmentProgress || !fragmentProgress.practiceResults){
            setCompleted(false)
        }

        if(fragmentProgress?.practiceResults){
            if(fragmentProgress?.practiceResults?.answer === "SKIPPED"){
                setSkipStatus(true)
            }
        }

        // Check if this practice exists in the practice results
        setCompleted(fragmentProgress?.practiceResults?.practiceId === practice.id);
    }, [lessonProgressData, lessonData])

    if (!promptCreationData) {
        return (
            <div className="practice-block">
                <div className="practice-block-content">
                    <p>Practice data not available</p>
                </div>
            </div>
        );
    }

    const handleStartPractice = () => {
        setShowDialog(true);
        onStart();
    };

    const handleCloseDialog = () => {
        setShowDialog(false);
        setEvaluationResult(null);
    };

    const handleReset = () => {
        setEvaluationResult(null)
    }

    const handleSubmitPrompt = async (prompt: string) => {
        console.log('Submitted prompt:', prompt);
        setIsEvaluating(true);

        try {
            const result = await evaluatePromptWithAi({
                prompt,
                practiceTask: practice.promptCreation?.fullDescription || ''
            });
            let parsedResult;
            if (typeof result.evaluation === 'string') {
                parsedResult = JSON.parse(result.evaluation);
            } else {
                parsedResult = result.evaluation;
            }
            setEvaluationResult(parsedResult);
        } catch (error) {
            setEvaluationResult({
                score: '0',
                comment: 'Error evaluating prompt. Please try again.',
                recommendedPrompt: ''
            });
        } finally {
            setIsEvaluating(false);
        }
    };

    return (
        <>
            <div className="practice-block">
                <div className="practice-block-content">
                    {!isSkip && isCompleted && (
                        <div className="practice-completed-badge">
                            <span className="practice-completed-icon">✓</span>
                            <span className="practice-completed-text">Task completed</span>
                        </div>
                    )}
                    <h3 className="practice-title">{promptCreationData.title}</h3>
                    <p className="practice-description">{promptCreationData.description}</p>
                    <button
                        className={`practice-start-btn ${!isSkip && isCompleted ? 'completed' : ''}`}
                        onClick={handleStartPractice}
                    >
                        {!isSkip && isCompleted ? (
                            <>
                                <span className="practice-repeat-icon">↻</span>
                                <span>Repeat task</span>
                            </>
                        ) : (
                            'Start Practice'
                        )}
                    </button>
                </div>
            </div>

            <PromptCreationDialog
                courseId={courseId}
                currentFragmentId={currentFragmentId}
                practice={promptCreationData}
                lessonId={lessonId}
                fragmentIndex={fragmentIndex}
                practiceId={practice.id}
                practiceType={practice.practiceType}
                onResetResult={handleReset}
                isOpen={showDialog}
                onClose={handleCloseDialog}
                onSubmit={handleSubmitPrompt}
                evaluationResult={evaluationResult}
                isEvaluating={isEvaluating}
                onCompleted={onCompleted}
                onMoveText={onMoveNext}
            />
        </>
    );
};
